export const SIZOTSA_REFERENCE_DATA = 'sizotsaFuneralCover/referenceData/';

// Service Actions
export const SIZOTSA_REFERENCE_DATA_SERVICE = SIZOTSA_REFERENCE_DATA + 'service/';

export const GET_BANKS_REFERENCE_DATA_VALUE = SIZOTSA_REFERENCE_DATA_SERVICE + 'getValue/banks';
export const GET_BRANCH_CODES_REFERENCE_DATA_VALUE = SIZOTSA_REFERENCE_DATA_SERVICE + 'getValue/branchCodes';
export const getBanksReferenceDataService = () => ({ type: GET_BANKS_REFERENCE_DATA_VALUE });
export const getBranchCodesReferenceDataService = (value) => ({ type: GET_BRANCH_CODES_REFERENCE_DATA_VALUE, value });

export const GET_AGENT_CODE=SIZOTSA_REFERENCE_DATA_SERVICE+'getAgentCode'

 export const getAgentCodeRequest=(value)=>({
type:GET_AGENT_CODE,
value
})
// export const PERSONAL_DETAILS_EDIT =
// SIZOTSA_BANKING_DETAILS +"setEdit";

// export const TOOGLE_INSURANCE_TYPE_PRIVACY_NOTICE =
// ALLSURE_INSURANCE_INSURANCE_TYPE+"toogle/privacyNotice";

export const SET_REFERENCE_DATA_VALUE = SIZOTSA_REFERENCE_DATA + 'setValue';
export const SET_REFERENCE_DATA_API_DETAILS_VALUE = SIZOTSA_REFERENCE_DATA + 'setValue/apiDetails';
// export const  tooglePrivacyNotice=(value)=>({type: TOOGLE_INSURANCE_TYPE_PRIVACY_NOTICE, value})
export const setSizotsaReferenceDetailsValue = (value) => ({ type: SET_REFERENCE_DATA_VALUE, value });
export const setSizotsaApiDetails = (value) => ({ type: SET_REFERENCE_DATA_API_DETAILS_VALUE, value });


export const SIZOTSA_APPLICATION_TOGGLE_TNC = SIZOTSA_REFERENCE_DATA + 't&C';

export const toggleTnC= (value) => ({
    type: SIZOTSA_APPLICATION_TOGGLE_TNC,
    value
});

export const SIZOTSA_APPLICATION_API_STATUS = SIZOTSA_REFERENCE_DATA + 'setApiStatus';

export const setSizotsaApplicationApiStatus = (value) => ({
    type: SIZOTSA_APPLICATION_API_STATUS,
    value
});

export const SET_PURCHASE_RESPONSE = SIZOTSA_REFERENCE_DATA + 'setPurchaseResponse';

export const setPurchaseServiceResponse = (value) => ({
    type: SET_PURCHASE_RESPONSE,
    value
});